module.exports = __webpack_public_path__ + "media/images/front/icons/logo_jsco-96672bd399c2bcfafba4c29aaec80d88.png";